<a class="metro-card rounded no-pointer" href="javascript: void(0)">
    <div class="card-image" [ngStyle]="{ 'background-image': 'url(' + image + ')' }">
      <div class="card-overlay">
        <div class="card-text-top">
          <div class="quote">“</div>
          <div class="sub">{{ description }}</div>
          <div class="title">{{ city.toUpperCase() }}</div>
        </div>
        <button class="cta-button sm" (click)="openPdfModal(id)">Metro {{ city }}</button>
      </div>
    </div>
</a>